import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services';
import { User } from '../_models';

@Injectable()
export class AuthGuard {
  private user: User;
  constructor(
    private authSvc: AuthenticationService,
    private router: Router
  ) {}

  /*
   * CanActivate: Guard to check if the user is authenticated and has the required roles
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // This code must come first to capture redirect URLs for specific slicks
    const slicksIntRegex = /^\/slicks\/\d+$/;
    if (slicksIntRegex.test(state.url)) {
      this.authSvc.redirectUrl = state.url;
    }

    if (!this.authSvc.user) {
      this.router.navigate(['/']);
      return false;
    }

    if (route.data.roles && !route.data.roles.includes(this.authSvc.user.role)) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
